import api from "../../services/api.service";
import { ActionTree } from "vuex";
import { ExternalMenuLinkState, ExternalMenuLink } from "./types";
import { RootState } from "../types";
export const actions: ActionTree<ExternalMenuLinkState, RootState> = {
	async loadExternalMenuLinks({ commit }) {
		const externalMenuLinks = await api.getAllExternalMenuLinks();
		if (externalMenuLinks && externalMenuLinks.data) {
			let data: ExternalMenuLink[] = externalMenuLinks.data;
			data.forEach(d => {
				d.iconFile = d.iconFile == "null" ? null : d.iconFile;
				d.iconName = d.iconName == "null" ? null : d.iconName;
			})
			commit("setExternalMenuLinks", data);
		}
	},

	async deleteExternalMenuLink({ commit }, externalMenuLinkId: number) {
		await api.deleteExternalMenuLink(externalMenuLinkId);
		commit("removeExternalMenuLink", externalMenuLinkId);
	},

	async createExternalMenuLink({ commit }, externalMenuLink: ExternalMenuLink) {
		const { data } = await api.createExternalMenuLink(externalMenuLink);

		commit("addNewExternalMenuLink", data);
	},

	async updateExternalMenuLink({ commit }, externalMenuLink: ExternalMenuLink) {
		const { data } = await api.updateExternalMenuLink(externalMenuLink);

		commit("updateExternalMenuLink", data);
	}
};
